import { render, staticRenderFns } from "./generic-modal.vue?vue&type=template&id=38a854a4&scoped=true&"
import script from "./generic-modal.vue?vue&type=script&lang=js&"
export * from "./generic-modal.vue?vue&type=script&lang=js&"
import style0 from "./generic-modal.vue?vue&type=style&index=0&id=38a854a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a854a4",
  null
  
)

export default component.exports